export const setRef = (forwardedRef, ref) => {
  if (forwardedRef && 'current' in forwardedRef) {
    forwardedRef.current = ref;
  } else if (forwardedRef) {
    forwardedRef?.(ref);
  }
};
export const refDefined = ref => ref && ref.current;
export const refContainsTarget = (ref, target) => ref && ref.current && ref.current.contains(target);
export const refParentContainsTarget = (ref, target) => ref && ref.current && ref.current.parentNode && ref.current.parentNode.contains(target);